import { useState } from 'react'
import { useWatchedMovies } from '../hooks/useFirestore'
import MovieGrid from '../components/movie/MovieGrid'
import './History.css'

function History() {
  const { movies, loading, removeMovie } = useWatchedMovies()
  const [filter, setFilter] = useState('all')
  const [sortBy, setSortBy] = useState('date')

  const filteredMovies = movies
    .filter(movie => {
      if (filter === 'all') return true
      if (filter === 'high') return movie.rating >= 4
      if (filter === 'low') return movie.rating <= 2
      return true
    })
    .sort((a, b) => {
      if (sortBy === 'date') {
        return new Date(b.watchedDate) - new Date(a.watchedDate)
      }
      if (sortBy === 'rating') {
        return (b.rating || 0) - (a.rating || 0)
      }
      if (sortBy === 'title') {
        return a.title.localeCompare(b.title)
      }
      return 0
    })

  return (
    <div className="page history-page">
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">📋 Mi historial</h1>
          <p className="text-secondary">
            {movies.length} película{movies.length !== 1 ? 's' : ''} vista{movies.length !== 1 ? 's' : ''}
          </p>
        </div>

        {movies.length > 0 && (
          <div className="history-filters">
            <div className="filter-group">
              <label>Filtrar:</label>
              <select 
                className="input filter-select"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                <option value="all">Todas</option>
                <option value="high">Favoritas (4-5 ⭐)</option>
                <option value="low">No me gustaron (1-2 ⭐)</option>
              </select>
            </div>

            <div className="filter-group">
              <label>Ordenar por:</label>
              <select 
                className="input filter-select"
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="date">Fecha vista</option>
                <option value="rating">Puntuación</option>
                <option value="title">Título</option>
              </select>
            </div>
          </div>
        )}

        <MovieGrid 
          movies={filteredMovies}
          loading={loading}
          showRating
          emptyMessage="Aún no has visto ninguna película. ¡Empieza buscando una!"
        />
      </div>
    </div>
  )
}

export default History
